import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["activator", "band", "date", "mode", "noResults", "results"]
  static values = { activator: String, band: String, date: String, mode: String }

  resultsTargetConnected() {
    this.applyFilters()
  }

  noResultsTargetConnected() {
    this.applyFilters()
  }

  activatorChanged(event) {
    this.activatorValue = event.target.value
    this.applyFilters()
  }

  bandChanged(event) {
    this.bandValue = event.target.value
    this.applyFilters()
  }

  bandChange(event) {
    const selected = event.target.options[event.target.selectedIndex]
    const modeOpts = [...document.getElementById('operation_mode_id').options]

    modeOpts.forEach((option) => {
      if (selected.text === '2 meter VHF') {
        if (option.text === 'FM Phone') {
          option.removeAttribute('disabled')
          option.setAttribute('selected', true)
        }
      } else {
        if (option.text === 'FM Phone') {
          option.removeAttribute('selected')
          option.setAttribute('disabled', true)
        }
      }
    })
  }

  clubChanged(event) {
    const href = window.location.origin + window.location.pathname + `?club_id=${event.target.value}`
    window.location.href = href
  }

  dateChanged(event) {
    this.dateValue = event.target.value
    this.applyFilters()
  }

  modeChanged(event) {
    this.modeValue = event.target.value
    this.applyFilters()
  }

  applyFilters() {
    const elements = [...document.querySelectorAll('table#operations tbody tr:not([data-operations-target="noResults"])')]
    const filters = [
      [this.activatorValue, 'activator'],
      [this.bandValue,      'band'],
      [this.dateValue,      'date'],
      [this.modeValue,      'mode'],
    ]

    let matchCount = 0
    elements.forEach((row) => {
      const visible = filters.every(([value, key]) => value === '' || row.dataset[key] === value)
      row.classList.toggle('d-none', !visible)
      if (visible) matchCount++
    })

    this.noResultsTarget.classList.toggle('d-none', matchCount > 0)
  }
}
